import React, { useMemo, useState } from "react";
import { Modal } from "../Modal/Modal";
import {
  sendPaymentLinkEmail,
  sendPaymentLinkEmailV2,
  expirePaymentLink,
  expirePaymentLinkV2,
} from "../../helpers/subscription";
import { Button } from "../Button/Button";
import { toast } from "react-toastify";
import Countdown from "../../pages/ClienteDados/components/Countdown";
import FloatToCurrency from "../../helpers/FloatToCurrency";
import { Spinner } from "../Spinner/Spinner";
import { useSelector } from "react-redux";

export default function CopySendLinkModal({ isOpen, onClose, codeLink, expirationDate, email, plan, isJussub }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExpire, setIsLoadingExpire] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const link = process.env.REACT_APP_JUSFY_URL + (isJussub ? `/payment-link/v2/${codeLink}` : `/payment-link/${codeLink}`);
  const [isExpired, setIsExpired] = useState(expirationDate <= new Date());
  const customer = useSelector(
      state => state.subscription.customer
    );

  const planAmount = useMemo(() => {
    if (isJussub) return plan?.amount;
    return FloatToCurrency(plan?.amount / 100)
  }, [plan, isJussub])

  const handleSendEmail = async () => {
    try {
      const name = customer?.name;
      const _email = customer?.email || email;
      setIsLoading(true);
      isJussub
        ? await sendPaymentLinkEmailV2(codeLink, name, _email, link)
        : await sendPaymentLinkEmail(codeLink, _email, link);
      toast.success("Email enviado com sucesso!");
      setEmailSent(true);
    } catch {
      toast.error("Ocorreu um erro ao enviar o email.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleExpireLink = async () => {
    try {
      setIsLoadingExpire(true);
      isJussub
        ? await expirePaymentLinkV2(codeLink)
        : await expirePaymentLink(codeLink);
      toast.success("Link expirado com sucesso!");
      setIsExpired(true);
    } catch {
      toast.error("Ocorreu um erro ao expirar o link.");
    } finally {
      setIsLoadingExpire(false);
    }
  };
  return (
    <Modal
      title="Link gerado com sucesso"
      subtitle="O link de pagamento foi gerado com sucesso, você pode copiar o link abaixo e enviar diretamente para o cliente ou enviar por email."
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content>
        <div className="border-top mb-5" style={{ borderColor: "#E7E8EC" }} />
        <div className="d-flex flex-column w-100 mt-7">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <p style={{ fontWeight: 500, fontSize: 14, margin: 0 }}>Plano</p>
            <p style={{ fontWeight: 500, fontSize: 14, margin: 0  }}>
              {plan?.name}
            </p>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center mt-5">
            <p style={{ fontWeight: 500, fontSize: 14, margin: 0 }}>Valor</p>
            <p style={{ fontWeight: 500, fontSize: 14, margin: 0 }}>
             R$ {planAmount}
            </p>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center mt-5">
            <p style={{ fontWeight: 500, fontSize: 14, margin: 0 }}>Pagamento</p>
            <div className={"d-flex flex-row justify-content-between align-items-center"} style={{padding: "8px 12px", backgroundColor: "#FFF9E6", borderRadius: 5}}>
              <Spinner primaryColor="#806400" size={10} />
              <p style={{ fontWeight: 500, fontSize: 14, margin: "0 0 0 8px" }}>Aguardando Pagamento</p>
            </div>
          </div>
        </div>
        <div className="border-top mt-5 mb-12" style={{ borderColor: "#E7E8EC" }} />
        <b>Link para pagamento</b>
        <div className="d-flex flex-row justify-content-between mt-2">
          <textarea
            id="paymentLink"
            value={link}
            rows={1}
            style={{
              width: "80%",
              backgroundColor: "#FAFBFF",
              borderRadius: 5,
              border: "1px solid #CAC9CF",
              padding: 10,
              fontSize: 14,
              resize: "none",
            }}
            onFocus={e => e.target.select()}
            readOnly
          />
          <Button
            outlined
            onClick={() => {
              navigator.clipboard
                .writeText(link)
                .then(() => toast.success("Link copiado com sucesso!"))
                .catch(() =>
                  toast.error(
                    "Não foi possível copiar o link. Copie manualmente."
                  )
                );
            }}
            icon="FileCopyOutlined"
          >
            Copiar
          </Button>
        </div>
        <div className="mt-8">
          <b>Email do cliente</b>
          <div className="d-flex flex-row justify-content-between mt-2">
            <textarea
              id="emailPaymentLink"
              value={email}
              rows={1}
              style={{
                width: "80%",
                backgroundColor: "#FAFBFF",
                borderRadius: 5,
                border: "1px solid #CAC9CF",
                padding: 10,
                fontSize: 14,
                resize: "none"
              }}
              onFocus={e => e.target.select()}
              readOnly
            />
            <Button
              outlined
              onClick={() => {
                handleSendEmail();
              }}
              icon={emailSent ? "CheckOutlined" : "SendOutlined"}
              loading={isLoading}
              disabled={isLoading || emailSent}
            > {emailSent ? "Enviado" : "Enviar"}
            </Button>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center mt-8">
          <p className="m-0">Link pode ser acessado por</p>
          <div className="d-flex flex-row align-items-center">
            {!isExpired && (
              <Countdown
                seconds={Math.floor((new Date(expirationDate) - new Date()) / 1000)}
                secondsStyle={{ fontWeight: "bold", fontSize: 14 }}
              />
            )}
            <Button secondary style={{ marginLeft: 24 }} loading={isLoadingExpire} onClick={() => handleExpireLink()} disabled={isExpired}>{isExpired ? "Expirado" : "Expirar"}</Button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
}
